import React from 'react'
import Link from 'gatsby-link'
import ReactGA from 'react-ga'

import logo from './pfb-logo.png'
import financials from './Annual_Report_Financials_2017_FINAL.pdf'

class Header extends React.Component {
  logger() {
    // Detect each click of the financial PDF
    ReactGA.event({
      category: 'Financial Download',
      action: 'User clicked link to view financials'
    })
  }

  render() {
    return (
      <div>
        <nav className="pfb-nav-container">
          <Link to="/locations">
            <img className="pfb-logo" src={logo} alt="People for Bikes Logo" />
          </Link>
          <ul className="pfb-nav-item-container">
            <li className="pfb-nav-item">
              <a href="https://peopleforbikes.org/shortsignup/" target="_blank">Join Us</a>
            </li>
            <li className="pfb-nav-item">
              <a href={financials} onClick={this.logger} target="_blank" id="pfb-financials-pdf">Financials</a>
            </li>
          </ul>
        </nav>
      </div>
    )
  }
}
export default Header


// WEBPACK FOOTER //
// ./src/components/Header/index.js